    import React, { useState, useEffect } from "react";
    import { width } from "../../../../CustomComponents/DynamicCard/DynamicCardStyles";
    import CustomTextInput from "../../../../CustomComponents/CustomtextInput";
    import RightArrow from "../../../../../assets/images/RightArrow@2x.png";
    import { useTranslation } from "react-i18next";
    import { useNavigate } from "react-router";
    import { useDispatch, useSelector } from "react-redux";
    import Loader from "../../../../CustomComponents/Loader";
    import DynamicCard from "../../../../CustomComponents/DynamicCard";
    import {
    handleAmountInputLimitTo2decimal,
    retrieveData,
    } from "../../../../../utils";
    import logFirebaseEvents from "../../../../LogFirebaseEvents";
    import CardHeading from "../../../../CustomComponents/CardHeading";
    import { appTheme, decimalValidation } from "../../../../../helpers/utils/Utils";
    import CustomRadioButton from "../../../../CustomComponents/CustomRadioButton";
    import {
    GET_ALLOCATE_FUND_FREQUENCIES,
    STATUS_SUCCESS_CODE,
    } from "../../../../../network/URLConstants";
    import {
    GetApiHeadersWithBearer,
    GetRequest,
    } from "../../../../../network/NetworkUtils";
    import { use } from "react";
import { withOidcSecure } from "@axa-fr/react-oidc";

const InstallMentAmount = ({ cardHeader, cardFooter, onBack, onNext }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue);
  const [amountError, setAmountError] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isNext, setIsNext] = useState(false);
  const amount = useSelector((state) => state.allocateFund.Installments);
  const frequency = useSelector((state) => state.allocateFund.Frequency);
  const accessToken = useSelector((state) => state.accessToken);
  const selectedFrequencyValueDATA = useSelector(
    (state) => state.selectedFrequencyValue
  );
  const [frequencyError, setFrequencyError] = useState(null);
  const [frequencyArray, setFrequencyeArray] = useState([]);
  const [selectedFrequency, setSelectedFrequency] = useState("");
  const savingsGoalAmount = useSelector((state) => state.savingGoals.amount);
  const [validFrequency, setValidFrequency] = useState(false);

 const AddAccountType = useSelector(state => state.savingGoalAccountTypeObj);
 const { AccountType, AccountName, AccountId } = AddAccountType;


  const accountObj = useSelector(state => state.accountTypes);

 console.log(AddAccountType)



  const setFrequencyFun = (value) => {
    setSelectedFrequency(value.DisplayText);
    if(value) {
      setValidFrequency(true);
    }
    dispatch({
      type: "SELECTED_FREQUENCY_VALUE",
      payload: { selectedFrequencyValue: value },
    });
  };

  const getFrequency = async () => {
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const url = GET_ALLOCATE_FUND_FREQUENCIES;
    try {
      const response = await GetRequest(url, headers);
      const responseJson = await JSON.parse(response);
      if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
        setFrequencyeArray(responseJson.Response);
        dispatch({
          type: "FREQUESCY_DATA",
          payload: { frequecyData: responseJson.Response },
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getFrequency();
  }, []);

   
  const handleBackClick = () => {
    logFirebaseEvents(
      "Allocate_Fund",
      "Back_Allocate_Clicked",
      "Back_Allocate_Clicked",
      "",
      ""
    );
    // dispatch({ type: "RESET_ALLOCATE_FUND" });
    navigate("/Climb/SavingGoals/ManageSavingGoal");
    dispatch({
      type: "SAVING_GOAL_ACCOUNT_TYPE_OBJ",
      payload: { savingGoalAccountTypeObj: {} }
    });
  };
  const handleNextClick = () => {
   
    if (AddAccountType && Object.keys(AddAccountType).length > 0) {
      dispatch({
        type: "SAVING_GOAL_ACCOUNT_TYPE_OBJ",
        payload: { savingGoalAccountTypeObj: AddAccountType }
      });
    } else {
      dispatch({
        type: "SAVING_GOAL_ACCOUNT_TYPE_OBJ",
        payload: { savingGoalAccountTypeObj: {} }
      });
    }
   
    logFirebaseEvents(
      "Allocate_Fund",
      "Next_Allocate_Clicked",
      "Next_Allocate_Clicked",
      "",
      ""
    );
    if (!amount) setAmountError("Amount Required");
    if (amount && !amountError) onNext("AccountName");
  };

    const handleOnBlur = (event) => {
        if (!amount) setAmountError("Amount Required");
        else if (amount <= 0) {
        setAmountError("Please enter amount greater than 0");
        }
        else if (amount) {
            const inputValue = event.target.value;
            const formattedAmount = handleAmountInputLimitTo2decimal(inputValue)
             const finalAmountVal = decimalValidation(formattedAmount)
            dispatch({ type: 'ALLOCATE_FUND', payload: { 'key': "Installments", 'value': finalAmountVal } })
        }
         else setAmountError("");
    };

  const amountValidation = () => {
    if (!amount) {
      setAmountError("Amount Required");
      setIsNext(false);
    } else if (amount <= 0) {
      setAmountError("Please enter amount greater than 0");
      setIsNext(false);
    } else if (amount.endsWith(".")) {
      setAmountError("Invalid amount format");
      setIsNext(false);
    } else if (parseFloat(amount) > parseFloat(savingsGoalAmount)) {
      setAmountError(t("The_fund_amount_should_be_less"));
      setIsNext(false);
    } else {
      setAmountError(null);
      setIsNext(true);
    }
  };

  useEffect(() => {
    if (amount) amountValidation();

    if (!amount) setIsNext(false);
  }, [amount]);

  // useEffect(() => {
  //     dispatch({ type: 'ALLOCATE_FUND', payload: { 'key': "Installments", 'value': '' } })
  // }, [])

  const children = () => {
    return (
      <>
        {/* {cardHeader} */}
        <div
          className="sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
            sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px] 
                text-[var(--text-clrs)] mt-6 sm:mx-0 mx-4"
        >
          {t("spending_alert_amount_content1")}
          <span className="text-[var(--text-body-clrs)]">
            {t("Like_to_allocate")}
          </span>
        </div>

        <div className="w-full flex justify-center">
          <div className="sm:w-[80%] w-full">
            {/* BODY */}
            <div className="md:my-20 sm:my-16 mt-10 mb-[10rem] sm:mx-0 mx-4">
              <div className="sm:w-[50%] w-full flex flex-col justify-center">
                <CustomTextInput
                  name={t("Installments")}
                  onKeyDown={(event) => {
                    if (event.key == "Enter") {
                      event.preventDefault();
                      event.target.style.opacity = 0.8;
                      setTimeout(() => {
                        event.target.style.opacity = 1;
                      }, 200);
                    }
                  }}
                onChange={(event) => {
                  const inputValue = event.target.value; // Remove invalid characters
                    const formattedAmount =
                    handleAmountInputLimitTo2decimal(inputValue);
                    setAmountError('');
                    // if (formattedAmount === "0" || /^0[^.]/.test(formattedAmount)) {
                    // return;
                    // }

                    // const [integerPart, decimalPart] =  formattedAmount.split(".");
                    // if (integerPart.length > 10) {
                    // return;
                    // }

                    // Dispatch updated amount
                    dispatch({
                    type: "ALLOCATE_FUND", payload: { key: "Installments", value: formattedAmount.toString().replace('$', '') }, });
                }}
              
                  value={amount ? `$${amount}` : ""}
                  error={amountError}
                  placeholder={"$ 0"}
                  inputWidth={` w-full`}
                  autoFocus={true}
                  // maxLength={"5"}
                  onBlur={(event) => handleOnBlur(event)}
                />
              </div>
              <div className="sm:w-[100%] w-full flex flex-col justify-center">
                <div className="mt-10">
                  <CustomRadioButton
                    title={t("frequency")}
                    options={frequencyArray}
                    frequency={selectedFrequencyValueDATA?.DisplayText}
                    onSelect={setFrequencyFun}
                    error={frequencyError}
                    isTextBelow={false}
                    isRow={"row"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* FOOTER */}

        {cardFooter(
          handleBackClick,
          handleNextClick,
          "",
          "",
          isNext 
        )}
      </>
    );
  };
  return (
    <>
      <DynamicCard
        header={false}
        CardRadius={true}
        cardWidth={width.homeCard}
        HeaderRadius={true}
        isWhite={appThemeData.isWhiteBgForCard}
        isDarkForKudzu={appThemeData.isDarkBgForCard}
        backgroundColor={"--cardHeading-bg"}
        HeaderContent={
          <>
            <CardHeading heading={t("Allocate_Funds")} />
          </>
        }
        footer={true}
      >
        {children()}
      </DynamicCard>
      {isLoading && <Loader />}
    </>
  );
};

export default withOidcSecure(InstallMentAmount);
